/**
 * Camlin Companion — stable per-browser visitor id (doc 116 §2.4/§7 D3, CO2).
 *
 * NOT a cross-site tracking id — one value per browser per site origin,
 * localStorage-backed (same posture as `consent.ts`). Used only for:
 *   - server-side proactive-engagement cap/dismiss enforcement
 *     (`engagementStore.ts` keys on `(siteKey, visitorId)`)
 *   - transcript-retention bookkeeping (`transcriptStore.ts`)
 * Both uses are already consent-gated by `CompanionWidget` — this module
 * only mints/reads the id, it never decides whether it's OK to use it.
 */

export const COMPANION_VISITOR_ID_STORAGE_KEY = 'camlin-companion-visitor-id-v1';

export interface CompanionVisitorIdStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

function defaultMakeId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `visitor-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getOrCreateCompanionVisitorId(
  storage: CompanionVisitorIdStorage,
  makeId: () => string = defaultMakeId
): string {
  const existing = storage.getItem(COMPANION_VISITOR_ID_STORAGE_KEY);
  if (existing && existing.trim()) {
    return existing;
  }

  const id = makeId();
  storage.setItem(COMPANION_VISITOR_ID_STORAGE_KEY, id);
  return id;
}
